import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { saveAs as importedSaveAs } from "file-saver";

import { ViajeRecorrido } from '../Models/ViajeRecorrido';
import { ReporteViaje } from '../Models/ReporteViaje';
import { ReporteVisita } from '../Models/ReporteVisita';
import { ReporteTarea } from '../Models/ReporteTarea';
import { Compania } from '../Models/Compania';

import { ViajeRecorridoService } from '../services/viaje-recorrido.service';
import { GlobalsService } from '../services/globals.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';
import { CompaniaService } from '../services/compania.service';
import { GeneradorTemplateService } from '../services/generador-template.service';
import { UtilesService } from '../services/utiles.service';

import {
  AccessibilityConfig, Action, AdvancedLayout, ButtonEvent, ButtonsConfig, ButtonsStrategy, ButtonType, Description, DescriptionStrategy, GalleryService,
  DotsConfig, GridLayout, Image, ImageModalEvent, LineLayout, PlainGalleryConfig, PlainGalleryStrategy, PreviewConfig
} from 'angular-modal-gallery';
//import { arch } from 'os';


@Component({
  selector: 'app-reporte-certificacion-cliente',
  templateUrl: './reporte-certificacion-cliente.component.html',
  styleUrls: ['./reporte-certificacion-cliente.component.css']
})
export class ReporteCertificacionClienteComponent implements OnInit {

  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;

  public reporteVisita: ReporteVisita = new ReporteVisita();
  public reporteVisitas: ReporteVisita[];

  public reporteTarea: ReporteTarea = new ReporteTarea();
  public reporteTareas: ReporteTarea[];

  public companiaModelo: Compania = new Compania();
  public path: any;
  public pathGaleria: any;
  public pathLogo: any;

  public url: any;

  public compania: string;
  public viaje: string;
  public visita: string;
  public urlPrueba: string;
  public markers = [];


  public datosPDF: any;

  public mostrarMapa: boolean = false;
  public mostrarAbortar: boolean = false;

  //public urldescarga = 'http://localhost/dtsarchivos/'

  images: any[];
  images1: Image[];

  constructor(private reporteService: ReporteViajeService, private globalServices: GlobalsService,
    private domSanitizer: DomSanitizer, private viajeRecorridoService: ViajeRecorridoService, private router: Router,
    private routerActivited: ActivatedRoute, private companiaServive: CompaniaService, private generadorTemplate: GeneradorTemplateService,
    private utilesService:UtilesService
  ) {

    this.urlPrueba = "http://www.eprac.com/DTS/reporte-certificacion/eprac/06CCD08A-710A-4D78-8F75-6AD54246CDC1/a3bbba68-8415-349d-2c50-6bc55171e787";

    //Obtiene los parametros de la url
    this.routerActivited.params.subscribe(params => {
      this.compania = params['compania'];
      this.viaje = params['idviaje'];
      this.visita = params['idvisita'];
    });
  }

  ngOnInit() {

    this.router.url;
    this.ObtenerCompania();

    this.CargarReporteVisitas(this.compania, null, null, this.viaje)

    //this.downloadFile1();
    this.ObtenerCompania();

    this.CargarReporteVisitas(this.compania, null, null, this.viaje)



  }





  cagarMapa(latitud: string, longitud: string) {

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: {
        lat: parseFloat(latitud),
        lng: parseFloat(longitud)
      },
      zoom: 18
    });

  }



  CrearPunto(latitud: number, longitud: number) {
    try {

      var marker = new google.maps.Marker({
        position: { lat: latitud, lng: longitud },
        map: this.map,

      });

      this.markers.push(marker);

    } catch (error) {

    }
  }


  ObtenerUrlString() {
    let arrayString = [];
    arrayString = this.urlPrueba.split("/");
    this.compania = arrayString[5];
    this.viaje = arrayString[6];
    this.visita = arrayString[7];


  }

  CargarReporteVisitas(idCompania: string, idUsuario: string, idVehiculo: string, idViaje: string) {
    try {


      this.reporteService.ObtenerReporteVisitas(idCompania, idUsuario, idVehiculo, idViaje).subscribe(
        data => {
          this.reporteVisitas = data;


          let index = this.reporteVisitas.findIndex(reporte => reporte.idVisita === this.visita);
          this.reporteVisita = this.reporteVisitas[index];



          this.CargarReporteTareas(this.reporteVisita.idVisita);
          this.path = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.reporteVisita.imagen);

          if (this.reporteVisita.estado === "PROCESADO") {
            this.mostrarAbortar = false;
          }
          else {
            this.mostrarAbortar = true;

            // this.images = [];
            // let count = 0;
            // let arrayimagen = [];

            // this.reporteTareas.forEach(element => {
            //   this.pathGaleria = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + element.imagen);

            //   count += 1;

            //   let imagen = new Image(count, { img: this.pathGaleria, description: element.descripcion });
            //   arrayimagen.push(imagen);
            // });
            // this.images1 = arrayimagen;
          }

          this.cagarMapa(this.reporteVisita.latitudEntrega, this.reporteVisita.longitudEntrega);

          this.CrearPunto(parseFloat(this.reporteVisita.latitudEntrega), parseFloat(this.reporteVisita.longitudEntrega));
        },
        err => {
          console.clear();
          console.log(err._body);

        });



    } catch (error) {
      console.log("CargarReporteVisitas: " + error);
    }

  }

  CargarReporteTareas(idVisita: string) {
    try {

      this.reporteService.ObtenerReporteTarea(this.compania, idVisita).subscribe(
        data => {
          this.reporteTareas = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReporteTareas: " + error);
    }

  }



  ObtenerCompania() {
    try {


      this.companiaServive.ObtenerCompania(this.compania).subscribe(
        data => {
          this.companiaModelo = data;
          this.pathLogo = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.companiaModelo.logo);
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("ObtenerCompania: " + error);
    }

  }


/**
 * Metodo que descarga el reporte
 */
  DescargarReporte() {
    //nombre que va a tener el archivo
    var nombre =  "Certificado " + this.reporteVisita.idVisita;
    var archivo = this.utilesService.getURLReportes() + nombre + ".pdf" ;

    //Genera el arciho PDF en la api
    this.generadorTemplate.downloadPDF(this.compania, this.viaje, this.reporteVisita.idVisita, nombre).subscribe(
      res => {
       
        if(res.tipoResultado==="ERROR"){
          swal("Error, "+ res.mensaje, "", "error");
            return
        }

        var resultado = 'data:application/pdf;base64,' + res.objetoResultado;
        var fileName = "Reporte Certificación.pdf";

        importedSaveAs(resultado, fileName);
      }
    )
  }








}